// extracted by mini-css-extract-plugin
module.exports = {"option":"buyCardsLink_option__Ba51A"};